import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const user = useSelector((state) => state.authentication.user);

  return (
    <Route
      {...rest}
      render={(props) =>
        user && allowedRoles.includes(user.type) ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;
